import {create} from 'zustand';

export interface StepperStore {
  prevSelectedStepId: string | null;
  selectedStepId: string | null;

  selectStep: (id: string) => void;
  goToPrevStep: () => void;
}

export const useStepperStore = create<StepperStore>((set, get) => ({
  prevSelectedStepId: null,
  selectedStepId: null,

  selectStep: (id) => {
    const {selectedStepId} = get();
    set({
      prevSelectedStepId: selectedStepId,
      selectedStepId: id,
    });
  },

  goToPrevStep: () => {
    const {prevSelectedStepId} = get();
    if (prevSelectedStepId) {
      set({
        selectedStepId: prevSelectedStepId,
        prevSelectedStepId: null,
      });
    }
  },
}));
